import { type ButtonHTMLAttributes, type ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type Variant = 'primary' | 'ghost' | 'outline' | 'danger';
type Size = 'sm' | 'md' | 'lg';

const VARIANT: Record<Variant, string> = {
    primary:  'bg-hattie-teal text-white hover:bg-hattie-teal/90 active:bg-hattie-teal',
    ghost:    'bg-transparent text-hattie-ink hover:bg-hattie-paper',
    outline:  'bg-transparent text-hattie-ink border border-hattie-stone hover:bg-hattie-paper',
    danger:   'bg-verdict-avoid text-white hover:bg-verdict-avoid/90',
};

const SIZE: Record<Size, string> = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-sm px-4 py-2',
    lg: 'text-base px-6 py-3',
};

const BASE = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus-visible:ring-2 focus-visible:ring-hattie-teal focus-visible:ring-offset-2 focus-visible:ring-offset-hattie-cream outline-none';

export function Button({
    variant = 'primary',
    size = 'md',
    className,
    children,
    ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }) {
    return (
        <button {...rest} className={twMerge(BASE, VARIANT[variant], SIZE[size], className)}>
            {children}
        </button>
    );
}

export function ButtonLink({
    variant = 'primary',
    size = 'md',
    className,
    children,
    ...rest
}: LinkProps & { variant?: Variant; size?: Size; children?: ReactNode }) {
    return (
        <Link {...rest} className={twMerge(BASE, VARIANT[variant], SIZE[size], className)}>
            {children}
        </Link>
    );
}
